"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalExcept = exports.getChildrenText = exports.highlight = void 0;
var React = require("react");
function highlight(s, term, exact) {
    if (exact === void 0) { exact = false; }
    if (s && term) {
        s = "" + s;
        if (exact) {
            return s == term ? React.createElement("span", { className: "hlt" }, "s") : s;
        }
        var parts = s.split(new RegExp(escapeRegex(term), "i"));
        if (parts.length == 1)
            return parts[0];
        var r = [];
        var index = 0;
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (r.length > 0) {
                var matched = s.substr(index, term.length);
                r.push(React.createElement("span", { className: "hlt", key: index }, matched));
                index += term.length;
            }
            r.push(part);
            index += part.length;
        }
        return r;
    }
    return s;
}
exports.highlight = highlight;
function escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function getChildrenText(children) {
    var label = "";
    React.Children.map(children, function (child) {
        if (typeof child == "string") {
            label += child;
        }
    });
    return label;
}
exports.getChildrenText = getChildrenText;
function equalExcept(left, right) {
    var exclude = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        exclude[_i - 2] = arguments[_i];
    }
    var excludeSet = new Set(exclude);
    var leftKeys = Object.keys(left);
    var rightKeys = Object.keys(right);
    if (leftKeys.length != rightKeys.length)
        return false;
    for (var _a = 0, leftKeys_1 = leftKeys; _a < leftKeys_1.length; _a++) {
        var key = leftKeys_1[_a];
        if (excludeSet.has(key))
            continue;
        if (left[key] != right[key])
            return false;
    }
    return true;
}
exports.equalExcept = equalExcept;
